<template>
  <v-container>
    <v-card>
      <v-toolbar
        dark
        color="primary"
      >
      <v-spacer/>
        <v-toolbar-title>Votação - Candidatos dos conselhos de cultura</v-toolbar-title>
        <v-spacer/>
      </v-toolbar>
    </v-card>
    <v-card class="elevation-1 pa-3 login-card">
          <v-card-title>
            <v-flex
           v-if="!usuarioLogado"
           title text-xs-center secondary--text
           >
            <a href="/eleitor/inscricao"><h3 class="primary--text">Para votar inscreva-se como eleitor e faça seu login.</h3></a>
          </v-flex>
          <v-flex v-else-if="eleitor && eleitor.no_regiao" title text-xs-center secondary--text>
            Selecione a região no mapa e conheça os candidatos, sua regiao é {{eleitor.no_regiao}}.
          </v-flex>
          <v-flex v-else title text-xs-center secondary--text>
            Selecione a região no mapa e conheça os candidatos
          </v-flex>
          </v-card-title>
    </v-card>
    <v-card class="elevation-1 pa-3 login-card">
          <v-card>
        <mapa v-model="regiao" />
      </v-card>
      </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Mapa from './Mapa';

export default {
  name: 'Votacao',
  components: { Mapa },
  data: () => ({
    regiao: '',
    usuarioLogado: false,
  }),
  watch: {
    regiao(valor) {
      if (!!valor) {
        window.location.href = `/votacao/${valor}`;
      }
    },
    usuario(perfil){
      this.usuarioLogado = perfil && perfil.no_perfil == 'eleitor';
      
      if(this.usuarioLogado){
        this.obterDadosEleitor(this.usuario.co_eleitor);
      }
    }
  },
  computed: {
    ...mapGetters({
        usuario: 'conta/usuario',
        perfil: 'conta/perfil',
        eleitor: 'eleitor/eleitor'
    }),
  },
  methods: {
    ...mapActions({
      obterUsuarioLogado: 'conta/tratarUsuarioLogado',
      obterDadosEleitor: 'eleitor/obterDadosEleitor',
    }),
  },
  mounted() {
    this.usuarioLogado = this.perfil && this.perfil.no_perfil == 'eleitor';
    if(this.usuarioLogado){
      this.obterDadosEleitor(this.usuario.co_eleitor);
    }
  },
};
</script>